export default {
  Id: 0,
  FirstName: "",
  LastName: "",
  BirthDate: "",
  UserName: "",
  Password: "",
  Email: "",
  SalesPersonCode: "",
  SupportSellerCode: "",
  CustomerServiceExec_: "",
  paymentAgentExec: ""
};
